import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import BASE_URL from "../config";

import $ from "jquery";
import "jquery-validation";
const EditProfile = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get("id"); // Get ID from URL query string

    const [formData, setFormData] = useState({
     
      personal_email: "",
      password: "",
      
      address: "",
      bio: "",
      image_url: "",
     
     
      emergency_phone: "",
      emergency_person_name: "",
      emergency_person_relation: "",
      facebook_link: "",
     
      linkedIn_link: "",
    });

    // Fetch user data with payments
    useEffect(() => {
        const token = localStorage.getItem("token");
        if (id) {
            fetch(`${BASE_URL}api/user/find-one/${id}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                }
            })
                .then(response => response.json())
                .then(data => {
                    console.log(data);
                    if (data) {
                        setFormData({
                         
                          personal_email: data.personal_email || "",
                          password: data.password || "",
                         
                          address: data.address || "",
                          bio: data.bio || "",
                          image_url: data.image_url || "",
                         
                        
                          emergency_phone: data.emergency_phone || "",
                          emergency_person_name: data.emergency_person_name || "",
                          emergency_person_relation: data.emergency_person_relation || "",
                          facebook_link: data.facebook_link || "",
                         
                          linkedIn_link: data.linkedIn_link || ""
                          
                        });
                    }
                })
                .catch(error => {
                    console.error("Error fetching User data:", error);
                    Swal.fire("Error", "Failed to fetch User data.", "error");
                });
        }
    }, [id]);

    // jQuery Validation Setup
    useEffect(() => {
      $("#editUserForm").validate({
          rules: {
            
              bio: "required",
              facebook_link: "required",
              linkedIn_link: "required",
              image_url: "required",
           
              personal_email: {
                  required: true,
                  email: true
              },
             
              address: "required",
              emergency_phone: {
                required: true,
                  digits: true,
                  minlength: 10,
                  maxlength: 12
              },
             
              emergency_person_name: "required",
              emergency_person_relation: "required",
          },
          messages: {
             
              bio: "Please enter a bio",
              facebook_link: "Please enter a Facebook Link",
              linkedIn_link: "Please enter a LinkedIn Link",
              image_url: "Please enter a Profile URL",
            
              personal_email: {
                  required: "Please enter a personal email",
                  email: "Enter a valid email"
              },
            
              address: "Please enter an address",
              emergency_phone: {
                  digits: "Only numbers allowed",
                  minlength: "Must be at least 10 digits",
                  maxlength: "Cannot exceed 12 digits"
              },
              emergency_person_name: "Please enter emergency contact name",
              emergency_person_relation: "Please enter emergency contact relation",
          },
          errorClass: "text-danger",
          submitHandler: function(form) {
              handleSubmit();
          }
      });
  }, []);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const token = localStorage.getItem("token");
        fetch(`${BASE_URL}api/user/update/${id}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
            body: JSON.stringify(formData)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error("Failed to update User data");
                }
                return response.json();
            })
            .then(data => {
                console.log("Updated User Data:", data);
                Swal.fire({
                    title: "Success!",
                    text: "User Updated Successfully!",
                    icon: "success",
                    confirmButtonText: "OK"
                }).then(() => {
                    window.location.href = "/Users"; // Redirect after success
                });
            })
            .catch(error => {
                console.error("Error updating User data:", error);
                Swal.fire({
                    title: "Error",
                    text: "Failed to update User data.",
                    icon: "error"
                });
            });
    };


    return (
        <div className="Users mt-4 mx-3">
            <h2 className="mb-3">Editing My Profile</h2>
            <form id="editUserForm" onSubmit={handleSubmit}>
          

<div className="row mb-3">
    <div className="col-md-6">
        <label className="form-label">Personal Email</label>
        <input type="text" className="form-control" name="personal_email" value={formData.personal_email} onChange={handleChange} required />
    </div>
    <div className="col-md-6">
        <label className="form-label">Address</label>
        <input type="text" className="form-control" name="address" value={formData.address} onChange={handleChange} />
    </div>
</div>

<div className="row mb-3">
    
    <div className="col-md-6">
        <label className="form-label">Profile Image URL</label>
        <input type="text" className="form-control" name="image_url" value={formData.image_url} onChange={handleChange} />
    </div>
</div>

<div className="row mb-3">
    
    <div className="col-md-12">
        <label className="form-label">Bio</label>
        <textarea className="form-control" name="bio" value={formData.bio} onChange={handleChange}></textarea>
    </div>
</div>



<h5>Emergency Contact</h5>
<div className="row mb-3">
    <div className="col-md-6">
        <label className="form-label">Emergency Phone</label>
        <input type="text" className="form-control" name="emergency_phone" value={formData.emergency_phone} onChange={handleChange} />
    </div>
    <div className="col-md-6">
        <label className="form-label">Emergency Contact Name</label>
        <input type="text" className="form-control" name="emergency_person_name" value={formData.emergency_person_name} onChange={handleChange} />
    </div>
</div>

<div className="row mb-3">
    <div className="col-md-6">
        <label className="form-label">Emergency Contact Relation</label>
        <input type="text" className="form-control" name="emergency_person_relation" value={formData.emergency_person_relation} onChange={handleChange} />
    </div>
</div>

<h5>Social Media Links</h5>
<div className="row mb-3">
    <div className="col-md-6">
        <label className="form-label">Facebook</label>
        <input type="text" className="form-control" name="facebook_link" value={formData.facebook_link} onChange={handleChange} />
    </div>
    <div className="col-md-6">
        <label className="form-label">LinkedIn</label>
        <input type="text" className="form-control" name="linkedIn_link" value={formData.linkedIn_link} onChange={handleChange} />
    </div>
</div>

                <button type="submit" className="btn btn-primary">Update Profile</button>
                <a href="/users" className="btn btn-secondary mx-3">Cancel</a>
            </form>
        </div>
    );
};

export default EditProfile;